import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react'

interface DevModeContextType {
  isDevModeEnabled: boolean
  setDevModeEnabled: (enabled: boolean) => void
}

const DevModeContext = createContext<DevModeContextType | undefined>(undefined)

const DEV_MODE_STORAGE_KEY = 'connect-dev-mode-enabled'

interface DevModeProviderProps {
  children: ReactNode
}

export function DevModeProvider({ children }: DevModeProviderProps) {
  const [isDevModeEnabled, setIsDevModeEnabled] = useState(() => {
    // Load from localStorage on initialization
    const saved = localStorage.getItem(DEV_MODE_STORAGE_KEY)
    return saved === 'true'
  })

  const setDevModeEnabled = (enabled: boolean) => {
    setIsDevModeEnabled(enabled)
    localStorage.setItem(DEV_MODE_STORAGE_KEY, enabled.toString())
  }

  useEffect(() => {
    // Persist to localStorage whenever state changes
    localStorage.setItem(DEV_MODE_STORAGE_KEY, isDevModeEnabled.toString())
  }, [isDevModeEnabled])

  return (
    <DevModeContext.Provider value={{ isDevModeEnabled, setDevModeEnabled }}>
      {children}
    </DevModeContext.Provider>
  )
}

export function useDevMode() {
  const context = useContext(DevModeContext)
  if (context === undefined) {
    throw new Error('useDevMode must be used within a DevModeProvider')
  }
  return context
}